<template>
  <div v-if="isVisible">
    <b-button v-b-toggle.sidebar-right class="help-button-style" variant="light">
      <b-icon icon="question-circle-fill" scale="0.7"></b-icon>
      Help
    </b-button>
    <b-sidebar id="sidebar-right" v-model="isShown" no-header right shadow>
      <template #default="{ hide }">
        <b-button class="float-right" variant="link-dark" @click="hide">
          <b-icon icon="x"></b-icon>
        </b-button>
        <div class="px-3 py-2">
          <p class="mt-4 help-button-text" style="color: #7F7FE4;">
            <b-icon icon="question-circle-fill" scale="1"></b-icon>
            Help & Support
          </p>
          <div v-if="isShown">
            <help-topics-categories :loading.sync="loading"></help-topics-categories>
            <div v-if="loading" class="text-center text-secondary my-2">
              <b-spinner class="align-middle" small></b-spinner>
              <strong>Loading...</strong>
            </div>
          </div>
        </div>
      </template>
      <template #footer>
        <div class="mb-4 p-3">
          <b-button block class="help-button-text" href="/support" pill variant="helpTopic">
            <b-icon icon="journal-bookmark-fill" scale="1"></b-icon>&nbsp;&nbsp;All Help Topics
          </b-button>
          <!--          <b-button block class="help-button-text" href="/support" pill variant="outline-helpTopic">-->
          <!--            <b-icon icon="headphones" scale="1"></b-icon>&nbsp;&nbsp;Contact Support-->
          <!--          </b-button>-->
        </div>
      </template>
    </b-sidebar>
  </div>
</template>
<script>
  import HelpTopicsCategories from './HelpTopicsCategories';

  export default {
    components: { HelpTopicsCategories },
    data() {
      return {
        isShown: false,
        loading: false,
        isVisible: !this.$route.path.includes('support'),
      };
    },
    watch: {
      $route() {
        this.isShown = false;
      },
    },
  };
</script>
<style>
  .help-button-style {
    position: fixed;
    bottom: 4px;
    right: 3px;
    background: #ffffff;
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
    border-radius: 8px 8px 8px 8px;
  }

  .help-button-text {
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.5px;
  }
</style>
